import { createElement } from 'react';
import Svg from './svg';
import './index.less';
const TitleBar4 = ({ width = 460, height = 36, color = '#4B9FFF', title, subTitle, style, extra, extraStyle, }) => {
    return (createElement("div", { className: "dv-title-bar", style: {
            width,
            height,
            ...(style || {}),
        } },
        createElement(Svg, { color: color, width: width, height: height }),
        createElement("div", { className: "dv-title-bar-content dv-title-bar-2" },
            createElement("div", { className: "dv-title-bar-title" }, title),
            createElement("div", { className: "dv-title-bar-sub-title" }, subTitle)),
        extra && (createElement("div", { className: "dv-title-bar-extra", style: extraStyle }, extra))));
};
export default TitleBar4;
